import r from "./ghl-ui.es1290.js";
var t = r(function(e, a, o) {
  return e + (o ? "-" : "") + a.toLowerCase();
});
const s = t;
export {
  s as default
};
